var map = {
	"./404.jpg": 7727,
	"./ankauf.jpg": 6119,
	"./art-shirt.jpg": 4519,
	"./banner/1.gif": 3194,
	"./box_schenken.png": 342,
	"./box_schenken_original.png": 7030,
	"./box_schenken_square.png": 9670,
	"./climate-partner.png": 6415,
	"./crew/alex.jpg": 4169,
	"./crew/constantin.jpg": 7092,
	"./crew/danny.jpg": 4303,
	"./crew/goetz.jpg": 8352,
	"./crew/ina.jpg": 2947,
	"./crew/matze.jpg": 3152,
	"./crew/max.jpg": 227,
	"./crew/tobi.jpg": 4377,
	"./crew/tom.jpg": 8285,
	"./environment.png": 8540,
	"./favicon.ico": 129,
	"./gogreen-small.webp": 3647,
	"./gogreen.org.png": 1428,
	"./gogreen.webp": 889,
	"./haendlerbund-siegel.org.png": 1545,
	"./haendlerbund-siegel.webp": 810,
	"./katalog.jpg": 5966,
	"./laden.webp": 7694,
	"./logo-small.webp": 4373,
	"./logo.org.png": 8122,
	"./logo.webp": 9179,
	"./logo_nl.png": 3153,
	"./logos/discogs.svg": 6061,
	"./paypal/de-checkout-medium.png": 4569,
	"./paypal/en-checkout-medium.png": 3777,
	"./paypal/f13-logo.png": 157,
	"./snow/0.png": 3027,
	"./snow/1.png": 7818,
	"./snow/2.png": 6801,
	"./snow/3.png": 8536,
	"./yt_icon_rgb.png": 1514,
	"./zahlung1.org.png": 5445,
	"./zahlung1.webp": 6310,
	"./zahlung2.org.png": 8422,
	"./zahlung2.webp": 1927
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;